import { Navigate, Outlet, useLocation } from 'react-router';

import { useViewer } from '@/entities/viewer';
import { LoadingState } from '@/shared/ui';

/**
 * Route guard for authenticated areas. UX only: the backend enforces access
 * on every request (SECURITY.md §30).
 */
export function RequireAuth() {
  const viewer = useViewer();
  const location = useLocation();

  if (viewer.status === 'loading') return <LoadingState />;
  if (viewer.status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

/** Login/register pages: an authenticated user goes straight to the app. */
export function GuestOnly() {
  const viewer = useViewer();
  if (viewer.status === 'loading') return <LoadingState />;
  if (viewer.status === 'authenticated') return <Navigate to="/app" replace />;
  return <Outlet />;
}
